import Author from './components/Author'
import KeyTakeaways from './components/KeyTakeaways'
import ModifiedDate from './components/ModifiedDate'
import RelatedPosts from './components/RelatedPosts'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Author,
  KeyTakeaways,
  ModifiedDate,
  RelatedPosts,
}
